import ReferralContainer from './trip-request-referral-container';

export default ReferralContainer;
